import { deDE, enUS, esES, frFR, trTR } from "@mui/x-data-grid/locales";

const dataGridLocales = {
  de: deDE,
  en: enUS,
  es: esES,
  fr: frFR,
  tr: trTR,
};

function normalizeLanguage(language) {
  const candidates = [language];

  try {
    candidates.push(localStorage.getItem("i18nextLng"));
  } catch (e) {
    // localStorage is unavailable in tests/SSR-like environments.
  }

  const match = candidates
    .filter(Boolean)
    .map((value) => String(value).toLowerCase().split("-")[0])
    .find((value) => dataGridLocales[value]);

  return match || "tr";
}

export function getMuiDataGridLocaleText(language, overrides = {}) {
  const languageCode = normalizeLanguage(language);
  const locale = dataGridLocales[languageCode] || dataGridLocales.tr;

  return {
    ...locale.components.MuiDataGrid.defaultProps.localeText,
    ...overrides,
  };
}
